import type { PreGameRoutine } from 'generated/openapi';
import { type HTMLAttributes, memo } from 'react';

import { PRE_GAME_ROUTINE_MAP } from '@/features/profile/utils/preGameRoutine';
import { Badge } from '@/shared/components/ui/badge';
import { Card } from '@/shared/components/ui/card';

export interface ProfileDetailsVibePreGameRitualProps extends HTMLAttributes<HTMLDivElement> {
  preGameRoutine?: PreGameRoutine;
}

export const ProfileDetailsVibePreGameRitual = memo(
  function ProfileDetailsVibePreGameRitual({
    preGameRoutine,
    ...props
  }: ProfileDetailsVibePreGameRitualProps) {
    if (!preGameRoutine) return null;

    const option = PRE_GAME_ROUTINE_MAP.get(preGameRoutine);
    if (!option) return null;

    return (
      <Card variant="data" {...props}>
        <p className="text-sm leading-5 font-bold">Pre-game ritual</p>
        <div className="flex flex-wrap gap-2">
          <Badge variant="display">
            {option.icon} {option.label}
          </Badge>
        </div>
      </Card>
    );
  },
);
